class MainStore {
  isApp;

  constructor() {
    this.isApp = window.isApp;
  }
}

const MainData = new MainStore();

export default MainData;
